<template>
  <section>
    <Divider class="mt-4 mb-4 bg-delta-grey" />
    <FormRow :fieldNameArr="[$t('QBR_PLANT_CODE'), '']" :col1Required="true">
      <AutoComplete
        v-model="qbrPlantCode"
        :placeholder="$t('QBR_PLANT_CODE')"
        element-id="qbrPlantCode"
        @on-search="search"
        clearable
        :disabled="!canUpdate"
        slot="a"
      >
        <Option v-for="(item, index) in qbrPlantCodeSourceList" :value="item" :key="index">{{ item }}</Option>
      </AutoComplete>
      <Button v-show="canUpdate" type="success" @click="add" slot="b">{{$t('ADD')}}</Button>
    </FormRow>
    <TablePage 
      :tableWidth="windowWidth"
      :columnsList="columnsList" 
      :resultList="qbrPlantCodeList"
    ></TablePage>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertDelete } from "@/util/alert"
import { Translate } from "@/util/common"

export default {
  name: "QBRPlantCodeMaintain",
  props: {
    qbrPlantCodeList: {
      type: Array,
      default: () => [],
    },
    group: {
      type: Object,
      default: () => null,
    },
  },
  components: {

  },
  data() {
    return {
      qbrPlantCode: "",
      qbrPlantCodeSourceList: [],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps:{
                innerHTML:  text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            let self = this
            return self.canUpdate
              ? h("Icon", {
                  props: {
                    type: "md-trash",
                    size: 28,
                  },
                  class: "text-delta-red",
                  on: {
                    click: () => {
                      self.remove(params.row)
                    },
                  },
                })
              : h("span")
          },
        },
        {
          title: this.$t('PLANT_CODE'),
          key: "qbrPlantCode",
          maxWidth: 150,
        },
        {
          title: this.$t('DESCRIPTION'),
          key: "description",
          maxWidth: 200,
        },
        {
          title: this.$t('LOCATION'),
          key: "location",
        },
        {
          title: this.$t('COMPANY_CODE'),
          key: "companyCode",
          maxWidth: 100,
        },
        {
          title: this.$t('AREA'),
          key: "area",
          maxWidth: 100,
        },
        {
          title: this.$t('COMPANY_NAME'),
          key: "companyName",
          maxWidth: 200,
        },
      ],
    }
  },
  created() {
    let vueInstance = this
    vueInstance.$vendorHttp
      .get("/group-account/" + vueInstance.group.uuid + "/data-control/QBR_PLANT")
      .then((response) => {
        response.data._embedded.dataControlResourceList.forEach((qurPlant) => {
          buildQBRPlant(vueInstance, qurPlant)
        })
      })
      .catch(() => {})
  },
  methods: {
    ...mapGetters(["getUserProfile", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    search() {
    },
    add() {
      const vueInstance = this
      if (!vueInstance.qbrPlantCode) {
        return AlertInfo(self, "請選擇QBR廠別").then(() => {
          setTimeout(() => document.getElementById("qbrPlantCode").focus(), 200)
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$authHttp
          .get("data-control/PLANT?plantCode=" + vueInstance.qbrPlantCode)
          .then((response) => {
            vueInstance.toggleLoading(false)
            buildQBRPlant(vueInstance, response.data)
            vueInstance.$linkDataControl(
              vueInstance,
              "QBR_PLANT",
              response.data.objectKey,
              vueInstance.group.code,
              "GROUP_USER"
            )
          })
          .catch((error) => {
            if (error.response.status == 444) {
              let text = vueInstance.$buildErrorMessage(error)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                text,
              })
            }
          })
      }
      this.qbrPlantCode = ""
    },
    remove(item) {
      const vueInstance = this
      AlertDelete(vueInstance, `QBR廠別 ${item.qbrPlantCode}`)
        .then(() => {
          vueInstance.toggleLoading(true)
          vueInstance.$unlinkDataControl(
            vueInstance,
            "QBR_PLANT",
            item.qbrPlantCode,
            vueInstance.group.code,
            "GROUP_USER"
          )
          vueInstance.qbrPlantCodeList.splice(item._index, 1)
        })
        .catch(() => {})
    },
  },
  computed: {
    canUpdate() {
      return (
        this.getUserProfile().systemFunctions != undefined &&
        this.getUserProfile().systemFunctions.includes("ACCOUNT_MGMT_GROUP_ACCOUNT_MAINTENANCE_GROUP_ACCOUNT_QBR_PLANT_RELATION_AREA_MODIFIABLE")
      )
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  },
}

function buildQBRPlant(vueInstance, ubrPlant) {
  let description = ""
  let location = ""
  let companyCode = ""
  let area = ""
  let companyName = ""
  ubrPlant.attributes.forEach((attribute) => {
    if (attribute.key == "description") {
      description = attribute.value
    }
    if (attribute.key == "location") {
      location = attribute.value
    }
    if (attribute.key == "companyCode") {
      companyCode = attribute.value
    }
    if (attribute.key == "area") {
      area = attribute.value
    }
    if (attribute.key == "companyName") {
      companyName = attribute.value
    }
  })
  vueInstance.qbrPlantCodeList.push({
    qbrPlantCode: ubrPlant.objectKey,
    description: description,
    location: location,
    companyCode: companyCode,
    area: area,
    companyName: companyName,
  })
}
</script>

<style scoped></style>
